/**
 * @fileoverview Logo Carousel
*/

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const LogoCarousel = {
    /**
     * Initializes the Swiper
     */
    init() {
        document.querySelectorAll('.wbcsd-logo-carousel').forEach(function(carousel) {
            let swiper = carousel.querySelector('.swiper');
            if (swiper) {
                new Swiper(swiper, {
                    direction: 'horizontal',
                    slidesPerView: 3,
                    spaceBetween: 5,
                    loop: true,

                    breakpoints: {
                        640: {
                          slidesPerView: 4,
                          spaceBetween: 5
                        },

                        1024: {
                          slidesPerView: 9,
                          spaceBetween: 5
                        }
                    },
                });
            }
        });

        document.querySelectorAll('.wbcsd-hero-carousel').forEach(function(carouselS) {
            let swiperHero = carouselS.querySelector('.swiper');
            let sliderNav = carouselS.querySelector('.home-slider-navigation');

            if (swiperHero) {
                let swiperHeroMain = new Swiper(swiperHero, {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    modules: [Autoplay, Navigation, Pagination],
                });

                swiperHeroMain.on('realIndexChange', function() {
                    let index = this.realIndex;
                    let current_data = this.slides[index].dataset.url;
                    document.getElementById('slider-bg').style.backgroundImage = `url('${current_data}')`;

                    Array.from(sliderNav.children).forEach(function(e) {
                        console.log('['+index+']');
                        if(e.getAttribute('data-index') === index.toString()){
                            e.classList.add('active');
                        } else {
                            e.classList.remove('active');
                        }
                    });
                });

                function slide(e){
                  let target = e.target;
                  if(target.classList[0] === 'nav-point'){
                    let index = target.getAttribute('data-index');
                    //console.log(index);
                    swiperHeroMain.slideToLoop(index, 500);          
                  }
                }

                sliderNav.addEventListener('click', slide);
            }
        });

        document.querySelectorAll('.wbcsd-testimonials-swiper').forEach(function(carousel) {
            let swiperTestim = carousel.querySelector('.swiper');
            if (swiperTestim) {
                new Swiper(swiperTestim, {
                    modules: [Navigation, Pagination],
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 10,
                    loop: true,

                    pagination: {
                        el: '.wbcsd-testimonials-swiper .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.wbcsd-testimonials-swiper .swiper-button-next',
                        prevEl: '.wbcsd-testimonials-swiper .swiper-button-prev',
                    }
                });
            }
        });

        document.querySelectorAll('.wbcsd-hero-testimonials').forEach(function(carousel) {
            let swiperTestim = carousel.querySelector('.swiper');
            if (swiperTestim) {
                new Swiper(swiperTestim, {
                    modules: [Navigation, Pagination],
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,

                    pagination: {
                        el: '.wbcsd-hero-testimonials .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.wbcsd-hero-testimonials .swiper-button-next',
                        prevEl: '.wbcsd-hero-testimonials .swiper-button-prev',
                    }
                });
            }
        });

    },
}

export default LogoCarousel;